import { render, staticRenderFns } from "./AddComponents.vue?vue&type=template&id=d9c99734&"
import script from "./AddComponents.vue?vue&type=script&lang=ts&"
export * from "./AddComponents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports